import React, { createContext, useContext } from 'react';
const ProfileDropdownContext = /*#__PURE__*/createContext(null);
export const ProfileDropdownProvider = ({
  close,
  children
}) => /*#__PURE__*/React.createElement(ProfileDropdownContext.Provider, {
  value: close
}, children);
export const useCloseProfileDropdown = () => {
  const context = useContext(ProfileDropdownContext);

  if (!context) {
    throw new Error('useCloseProfileDropdown must be used within an ProfileDropdownProvider');
  }

  return context;
};